import React from 'react'
import { Button, Card, CardHeader, Col, Row } from 'reactstrap';

const SelectPropertyListItem = ({
    name,
    dni,
    propertyId,
    username,
    onSelect,
    selected
}) => {


    return (
        <Card className='shadow-none border-top p-0' data-testid="ProviderItem">
            <Button color={`falcon-default`} className="border-none shadow-none text-left p-0" onClick={() => onSelect(propertyId)}>
                <CardHeader className={propertyId === selected ? 'bg-secondary' : ''}>
                    <Row>
                        <Col className="d-flex align-items-center">
                            <div className="media-body">
                                <p className="m-0">{dni ? dni : 'Propietario'}</p>
                                <h6 className="mb-0 font-weight-semi-bold">
                                    <span className="text-900">{username} | {name}</span>
                                </h6>
                            </div>
                        </Col>
                    </Row>
                </CardHeader>
            </Button>
        </Card>
    )
}


export default SelectPropertyListItem;